import { useQuery } from "@tanstack/react-query";

export function GetPagos() {
   const url = process.env.REACT_APP_URL_DIR + "formaspago";
   const token = localStorage.getItem("token");
   return useQuery({
      queryKey: ["pagos"],
      queryFn: () =>
         fetch(url, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json()),
   });
}

// export default GetPagos;